export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("auxiliaryCoolingEquipment.equipment")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.brand")]: {
          field: "brand",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.model")]: {
          field: "model",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.chip")]: {
          field: "chip",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.width")]: {
          field: "width",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.height")]: {
          field: "height",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.depth")]: {
          field: "depth",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
        [this.$t("common.updatedDate")]: {
          field: "updatedDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
      };
    },
  },
};
